/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, OnChanges, SimpleChanges, Output } from '@angular/core';
import { PropertiesListItemsVM } from '../../models/sysque-properties-list-vm';

@Component({
  selector: 'sysque-properties-list',
  templateUrl: './sysque-properties-list.component.html',
  styleUrls: ['./sysque-properties-list.component.scss'],
  standalone: false
})
export class SysquePropertiesListComponent implements OnChanges {
  @Input() propertiesListItems: PropertiesListItemsVM[];
  @Output() valueChanged: EventEmitter<{value: string, label: string}> = new EventEmitter<{value: string, label: string}>();

  items: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['propertiesListItems'] && this.propertiesListItems) {
      this.items = this.propertiesListItems.map(item => ({
        label: item.label,
        value: item.value,
        isEditable: item.isEditable
      }));
    }
  }

  public onValueChanged($event: string, label: string): void {
    this.valueChanged.emit({ value: $event, label: label });
  }
}